import { LandingPageResponse } from '@bgea-js/form-templates';
import customConfirmationCross from "../../../../src/content/the-cross/customConfirmation";
import * as React from 'react';
export default {
  LandingPageResponse,
  customConfirmationCross,
  React
};